import {useEffect, useState} from "react";
import Step from "./Step";
import TransactionsTable from "../TransactionsTable";

export default function AboutTransactions({index}) {
  const [transaction, setTransaction] = useState(null);
  const [canProceed, setCanProceed] = useState(false);
  const [busyReason, setBusyReason] = useState();

  useEffect(() => {
    fetch("/api/on_ramp/example_data")
      .then(response => response.json())
      .then(data => {
        setTransaction(data.transactions.uncategorized);
      }).catch(console.error);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      fetch("/api/on_ramp/status")
        .then(response => response.json())
        .then(data => {
          if(data.can_see_categorized) {
            setCanProceed(true);
            clearInterval(interval);
          }
          else {
            setBusyReason("Please wait while we categorize your transactions");
          }
        }).catch(console.error);
    }, 2000);
    return () => clearInterval(interval);
  }, []);


  if (!transaction) return "";
  return <Step index={index} title="About Transactions"
               canProceed={canProceed}
               busyReason={busyReason}>

    <p>
      Prosperity analzes all of your financial transactions from your
      checking, savings, and credit card accounts. We use Artificial
      Intelligence to categorize your transactions. Here's an
      example transaction:
    </p>
    <TransactionsTable transactions={[transaction]} with_cents columns={["account_name", "description"]}/>
    <p>
      One of the challenging things about categorizing transactions is that the description
      is often messy. There is no standard approach for how financial institutions
      describe a transaction, and that means that transaction data is hard to categorize
      automatically, espeically when it comes from many accounts and instititutions.
    </p>
    <p>
      Fortunately, AI is really good at this sort of analysis.
    </p>
  </Step>
}